import styled from 'styled-components'

export const Form = styled("form")`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px 43px;
  margin-top: 20px;
`;
